module.exports = __webpack_public_path__ + "img/logo-montreal.17c160c1.png";